export function truncate(text: string, max = 10) {
  //just return the text if it is empty
  if (!text) return text ?? ''

  if (text.length > max) {
    return `${text.substring(0, max)}...`
  } else {
    return text
  }
}
